import { render, staticRenderFns } from "./FeaturedDesigners.vue?vue&type=template&id=ca56586c&scoped=true&"
import script from "./FeaturedDesigners.vue?vue&type=script&lang=js&"
export * from "./FeaturedDesigners.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedDesigners.vue?vue&type=style&index=0&id=ca56586c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca56586c",
  null
  
)

export default component.exports